import "core-js/modules/es.array.map";

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:
 */
import Immutable from 'immutable';
import NavigationMenuRecord from '../../records/NavigationMenuRecord';
import * as actions from './actions';
var initialState = new NavigationMenuRecord();

function navigationMenuReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actions.NAVIGATION_MENU_OPEN:
      return state.merge({
        activeMenuId: action.menuId,
        menuOpen: true,
        isClosing: false
      });

    case actions.NAVIGATION_MENU_CLOSE:
      if (!state.activeMenuId) {
        // in addition to expected triggers, close is also dispatched
        // before each open action to handle switching between menus
        // if a menu isn't open when this occurs, the action is ignored
        return state;
      }

      return state.merge({
        activeMenuId: null,
        menuOpen: false,
        isClosing: false,
        mastheadNavigationItems: state.mastheadNavigationItems.update(state.activeMenuId, function (menu) {
          return menu.map(function (link) {
            return link.merge({
              open: false
            });
          });
        })
      });

    case actions.NAVIGATION_MENU_START_CLOSE:
      return state.merge({
        isClosing: true
      });

    case actions.NAVIGATION_MENU_CONFIG_SET:
      {
        var _action$payload = action.payload,
            mastheadNavigationConfig = _action$payload.mastheadNavigationConfig,
            footerNavigationConfig = _action$payload.footerNavigationConfig,
            navigationItems = _action$payload.navigationItems;
        return state.merge({
          mastheadNavigationItems: mastheadNavigationConfig,
          footerNavigationItems: footerNavigationConfig,
          navigationItems: navigationItems
        });
      }

    case actions.NAVIGATION_MENU_CONFIG_CLEAR:
      return state.merge({
        mastheadNavigationItems: Immutable.OrderedMap(),
        footerNavigationItems: Immutable.OrderedMap()
      });

    case actions.NAVIGATION_MENU_TOGGLE_SUB_MENU:
      {
        return state.updateIn(['mastheadNavigationItems', state.activeMenuId], function (menu) {
          return menu.map(function (link) {
            return link.merge({
              open: action.linkId === link.linkId ? !link.open : false
            });
          });
        });
      }

    case actions.NAVIGATION_MENU_SET_PLATFORM_NAME:
      {
        return state.merge({
          platformName: action.platformName
        });
      }

    default:
      return state;
  }
}

export default navigationMenuReducer;